<script lang="ts" setup>
import { createContact } from '~/queries/contact'
const form = ref({
  firstName: null,
  lastName: null,
  email: null,
  phone: null,
  content: null,
})
const loading = ref(false)
const messageSent = ref(false)
const messageError = ref(false)
const submitForm = (e) => {
  loading.value = true
  execQuery(createContact, form.value)
    .then(() => {
      loading.value = false
      form.value = {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        content: null,
      }
      messageSent.value = true
    })
    .catch((e) => {
      loading.value = false
      messageError.value = true
      console.error(e)
    })
}
</script>
<template>
  <div>
    <PatternHero size="small" color-class="text-primary-400">
      <div class="p-3 lg:p-6">
        <h2
          class="text-mobile-2xl font-semibold first-letter:uppercase md:text-xl"
        >
          {{ $t('contact.contact_title') }}
        </h2>
      </div>
    </PatternHero>
    <div class="mx-auto max-w-7xl px-6 pt-6 md:pt-10 xl:px-0">
      <h3 class="text-mobile-xl first-letter:uppercase md:mt-10 md:text-lg">
        <template>
          {{ $t('contact.contact_description') }}
        </template>
      </h3>
      <form class="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
        <label class="block md:mr-2">
          <span class="inline-block text-shade-900 first-letter:uppercase">
            {{ $t('contact.first_name') }} *
          </span>
          <input
            v-model="form.firstName"
            type="text"
            class="mt-1 block w-full border border-shade-900 outline-none ring-2 ring-transparent placeholder:text-shade-400 focus:border-transparent focus:ring-2 focus:ring-primary-400"
            placeholder="Audrey"
            required
          />
        </label>
        <label class="block md:ml-2">
          <span class="inline-block text-shade-900 first-letter:uppercase">
            {{ $t('contact.last_name') }} *
          </span>
          <input
            v-model="form.lastName"
            type="text"
            class="mt-1 block w-full border border-shade-900 outline-none ring-2 ring-transparent placeholder:text-shade-400 focus:border-transparent focus:ring-2 focus:ring-primary-400"
            placeholder="Dupont"
            required
          />
        </label>
        <p class="col-span-full font-semibold first-letter:uppercase">
          {{ $t('contact.contact_details') }}
        </p>
        <label class="block md:mr-2">
          <span class="inline-block text-shade-900 first-letter:uppercase">
            {{ $t('contact.email_address') }} *
          </span>
          <input
            v-model="form.email"
            type="text"
            class="mt-1 block w-full border border-shade-900 outline-none ring-2 ring-transparent placeholder:text-shade-400 focus:border-transparent focus:ring-2 focus:ring-primary-400"
            placeholder="audrey.dupont@company.com"
            required
          />
        </label>
        <label class="block md:ml-2">
          <span class="inline-block text-shade-900 first-letter:uppercase">
            {{ $t('contact.phone_number') }}
          </span>
          <input
            v-model="form.phone"
            type="text"
            class="mt-1 block w-full border border-shade-900 outline-none ring-2 ring-transparent placeholder:text-shade-400 focus:border-transparent focus:ring-2 focus:ring-primary-400"
            placeholder="0668693697"
          />
        </label>
        <label class="col-span-full block">
          <span class="inline-block text-shade-900 first-letter:uppercase">
            {{ $t('contact.message') }} *
          </span>
          <textarea
            v-model="form.content"
            class="mt-1 block w-full border border-shade-900 outline-none ring-2 ring-transparent placeholder:text-shade-400 focus:border-transparent focus:ring-2 focus:ring-primary-400"
            placeholder="Message"
            cols="30"
            rows="10"
          />
        </label>
        <p class="col-span-full text-sm text-shade-500">
          {{ $t('booking.required_fields') }}
        </p>
      </form>
      <div
        v-if="messageSent"
        class="flex bg-green-100 rounded-lg p-4 mb-4 text-sm text-green-700"
      >
        {{ $t('contact.contact_sent') }}
      </div>
      <div
        v-else-if="messageError"
        class="flex bg-red-100 rounded-lg p-4 mb-4 text-sm text-red-700"
      >
        {{ $t('contact.contact_error') }}
      </div>
      <div class="mt-6 flex flex-col justify-end gap-4 md:flex-row md:gap-6">
        <BasicButton :disabled="loading" :loading="loading" @click="submitForm">
          <span class="first-letter:uppercase">
            {{ $t('labels.submit') }}
          </span>
        </BasicButton>
      </div>
    </div>
  </div>
</template>
